<fullscreen-page>
  <navigation-column>
    <div class="h-100 d-flex flex-column">              
      <div class="p-2 flex-fill overflow-hidden">
        <dx-data-grid class="h-100"
                      (onToolbarPreparing)="onToolbarPreparing($event)"
                      [dataSource]="model"
                      [remoteOperations]="false"
                      [allowColumnReordering]="true"
                      [rowAlternationEnabled]="true"
                      [allowColumnResizing]="true"
                      noDataText="{{ 'keine Trainings im Account' | translate }}"
                      [showBorders]="true"
                      (onRowClick)="onSelectionChangedClick($event)"
                      (onRowRemoving)="onDeleteClicked($event)">
          <div *dxTemplate="let toolbaritem of 'addButtonTemplate'">
            <dx-button stylingMode="text" type="default" text="{{ 'Neues Training' | translate }}" (onClick)="addSingle()"></dx-button>

          </div>
          <dxo-editing mode="row" [allowDeleting]="true" [allowUpdating]="false" [useIcons]="true"></dxo-editing>
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
          <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" placeholder="{{ 'Training suchen' | translate }}"></dxo-search-panel>

          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="TeachingSetsStateNewUIV2"></dxo-state-storing>

          <dxi-column dataField="name" caption="{{ 'Name' | translate }}"></dxi-column>
          <dxi-column dataField="state" caption="{{ 'Status' | translate }}" cellTemplate="stateTemplate"></dxi-column>
          <div *dxTemplate="let state of 'stateTemplate'">
            {{getStateDesc(state.displayValue)}}
          </div>

        </dx-data-grid>
      </div>
    </div>
  </navigation-column>
  <content-column helpSwitch="true" look="light">
    <div slot="content" class="h-100 px-3">
      <dx-scroll-view *ngIf="teachingSetService.selectedSet" showScrollbar="always">
        <teachingset></teachingset>        
      </dx-scroll-view>
    </div>
  </content-column>
  <help-column class="{{modelService.systemService.showHelp ? '' : 'd-none'}}"></help-column>
</fullscreen-page>
